// import Modal from "components/Models/index";
// import useScreenMobile from "hooks/useScreen";
// import React, { useState } from "react";
// import "./role.scss";
// import Drawer from "components/Drawer/index";
// import CreateRole from "./CreateRole/index";
// import AssignAccess from "./AssignAccess/index";

// const RoleContent = ({ onSubmit, handleCancel }) => {
//   const [steps, setSteps] = useState("role");
//   const [roleData, setRoleData] = useState({
//     roleName: "",
//     users: [],
//     teams: [],
//     operations: []
//   });

//   const handlestep = () => setSteps("assign");

//   const updateRoleName = (name) => {
//     setRoleData((prev) => ({ ...prev, roleName: name }));
//   };

//   const updateUsers = (users) => {
//     setRoleData((prev) => ({ ...prev, users }));
//   };

//   const updateTeams = (teams) => {
//     setRoleData((prev) => ({ ...prev, teams }));
//   };

//   const updateOperations = (operations) => {
//     setRoleData((prev) => ({ ...prev, operations }));
//   };

//   return (
//     <div className="Role">
//       <div className="RoleTop">
//         <h1>Create a Role</h1>
//         <p className="text">Create role for the user in the organization</p>
//         <div className="RoleStepper">
//           <div
//             className="Rolesteps first"
//             style={{ cursor: "pointer" }}
//             onClick={() => {
//               if (steps === "assign") {
//                 setSteps("roles");
//               }
//             }}
//           >
//             <div className="step">
//               <span>1</span>
//             </div>
//             <p>Create Role</p>
//           </div>
//           <span className="RoleStepperLine"></span>
//           <div
//             className={`Rolesteps  ${steps === "assign" ? "first" : ""}`}
//             style={{ cursor: "pointer" }}
//           >
//             <div className="step">
//               <span>2</span>
//             </div>
//             <p>Assign Access</p>
//           </div>
//         </div>
//       </div>
//       {steps === "assign" ? (
//         <AssignAccess
//           updateUsers={updateUsers}
//           updateTeams={updateTeams}
//           updateOperations={updateOperations}
//           initialUsers={roleData.users}
//           initialTeams={roleData.teams}
//           initialOperations={roleData.operations}
//           onSubmit={onSubmit}
//           handleCancel={handleCancel}
//           roleData={roleData}
//         />
//       ) : (
//         <CreateRole
//           handlestep={handlestep}
//           updateRoleName={updateRoleName}
//           updateOperations={updateOperations}
//           initialRoleName={roleData.roleName}
//           initialOperations={roleData.operations}
//         />
//       )}
//     </div>
//   );
// };

// function Role({ handleCancel, onAddRole }) {
//   const isMobile = useScreenMobile({ size: 992 });
//   return (
//     <>
//       {isMobile ? (
//         <Drawer showFooter={false} handleCancel={handleCancel} isVisible={true}>
//           <RoleContent onSubmit={onAddRole} handleCancel={handleCancel} />
//         </Drawer>
//       ) : (
//         <Modal
//           title="Create Role"
//           showFooter={false}
//           showCross={true}
//           handleCancel={handleCancel}
//           padding="40px"
//         >
//           <RoleContent onSubmit={onAddRole} handleCancel={handleCancel} />
//         </Modal>
//       )}
//     </>
//   );
// }

// export default Role;


import Modal from "components/Models/index";
import useScreenMobile from "hooks/useScreen";
import React, { useState } from "react";
import "./role.scss";
import Drawer from "components/Drawer/index";
import CreateRole from "./CreateRole/index";

const RoleContent = ({ onSubmit, handleCancel }) => {
  const [roleData, setRoleData] = useState({
    roles: "",
    operations: []
  });
  // const [roleName, setRoleName] = useState("");
  // const [roleOperations, setRoleOperations] = useState([]);

  const handlestep = () => {
    // onSubmit({roleName, roleOperations});
    onSubmit(roleData);
    // console.log("Role Data:", roleData);
    handleCancel();
  };

  const updateRoles = (name) => {
    // setRoleName((prev) => ({ ...prev, name }));
    setRoleData((prev) => ({ ...prev, roles: name }));
  };

  const updateOperations = (operations) => {
    // setRoleOperations((prev) => ({ ...prev, operations }));
    setRoleData((prev) => ({ ...prev, operations }));
    
  };

  return (
    <div className="Role">
      <div className="RoleTop">
        <h1>Create a Role</h1>
        <p className="text">Create role for the user in the organization</p>
      </div>
      <CreateRole
        handlestep={handlestep}
        updateRoles={updateRoles}
        updateOperations={updateOperations}
        // initialRoles={roleName}
        // initialOperations={roleOperations}
        initialRoles={roleData.roles}
        initialOperations={roleData.operations}
      />
    </div>
  );
};

function Role({ handleCancel, onAddRole }) {
  const isMobile = useScreenMobile({ size: 992 });
  return (
    <>
      {isMobile ? (
        <Drawer showFooter={false} handleCancel={handleCancel} isVisible={true}>
          <RoleContent onSubmit={onAddRole} handleCancel={handleCancel} />
        </Drawer>
      ) : (
        <Modal
          title="Create Role"
          showFooter={false}
          showCross={true}
          handleCancel={handleCancel}
          padding="40px"
        >
          <RoleContent onSubmit={onAddRole} handleCancel={handleCancel} />
        </Modal>
      )}
    </>
  );
}

export default Role;